import { render, staticRenderFns } from "./FormElementLongTextInput.vue?vue&type=template&id=755a5f7a"
import script from "./FormElementLongTextInput.vue?vue&type=script&lang=js"
export * from "./FormElementLongTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports